import ccRequestApi from '../../api/coordinatedCoverageRequest'

// actions
const actions = {
  create ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      ccRequestApi.create(params, ccRequest => {
         const message = `Coordinated Coverage Request created!`
         dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
         resolve(ccRequest)
      },
      error => {
         const message = `Something went wrong creating that request...`
         dispatch('global/showSnackbarError', { message: message }, { root: true })
         reject()
      })
    })
  },

  get ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      ccRequestApi.get(id, ccRequest => {
         resolve(ccRequest)
      },
      error => {
         reject()
      })
    })
  },

  accept ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      ccRequestApi.accept(id, ccRequest => {
        resolve(ccRequest)
      },
        error => {
          reject(error)
        })
    })
  },

  reject ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      ccRequestApi.reject(id, ccRequest => {
        resolve(ccRequest)
      },
        error => {
          reject()
        })
    })
  },

  cancel ({ dispatch, commit }, id) {
    return new Promise((resolve, reject) => {
      ccRequestApi.cancel(id, ccRequest => {
        resolve(ccRequest)
      },
        error => {
          reject()
        })
    })
  },
}

export default {
  namespaced: true,
  actions,
}
